import { render, staticRenderFns } from "./disposalProposal.vue?vue&type=template&id=77feadf4&scoped=true&"
import script from "./disposalProposal.vue?vue&type=script&lang=js&"
export * from "./disposalProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77feadf4",
  null
  
)

export default component.exports